import { render, staticRenderFns } from "./TransferredSalesNumberIndicator.vue?vue&type=template&id=ce8d7c34&scoped=true"
import script from "./TransferredSalesNumberIndicator.vue?vue&type=script&lang=js"
export * from "./TransferredSalesNumberIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce8d7c34",
  null
  
)

export default component.exports